import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/components/Peep";

export default function Messages() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/notifications").then((r) => setD(r.data)).catch(() => setD({ items: [] }));
    api.post("/notifications/read-all").catch(() => {});
  }, []);
  return (
    <div data-testid="messages-screen" className="px-5 pt-6 pb-6">
      <h1 className="text-2xl font-extrabold">Messages</h1>
      <p className="text-sm text-[#a7a0af]">Messages from PEEPING about your account and memberships. Chat with creators happens live inside each broadcast; private direct messages aren't available yet.</p>
      <ul className="mt-4 flex flex-col gap-2">
        {d?.items.length === 0 && <li data-testid="messages-empty" className="text-sm text-[#a7a0af]">No messages yet.</li>}
        {d?.items.map((n) => (
          <li key={n.id} className="rounded-2xl border border-[#6a00ff]/25 bg-[#0f0a15] p-3">
            <p className="text-sm font-semibold">{n.title}</p>
            <p className="text-xs text-[#c7c1cf]">{n.body}</p>
            <p className="mt-1 text-[0.6rem] text-[#6f6878]">{fmtDate(n.created_at)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
